module.exports = __webpack_public_path__ + "img/bg_9.88d906cb.png";